import {
  CHAT_MESSAGE_MAX_LENGTH,
  CHAT_PHOTO_MAX_SIZE,
  CHAT_VIDEO_MAX_SIZE,
  GIFT_PHOTO_SIZE_RANGE,
  PUBLICATION_INTEREST_MAX_COUNT,
  PUBLICATION_PHOTO_SIZE_RANGE,
  PUBLICATION_VIDEO_SIZE_RANGE,
  USER_AVATAR_SIZE_RANGE,
} from 'config/settings';

export const authSelector = (state) => state.authState;
export const settingsSelector = (state) => state.settings;

export const publicationPhotoSizeRangeSelector = state => settingsSelector(state).data?.[PUBLICATION_PHOTO_SIZE_RANGE];
export const publicationVideoSizeRangeSelector = state => settingsSelector(state).data?.[PUBLICATION_VIDEO_SIZE_RANGE];
export const userAvatarSizeRangeSelector = state => settingsSelector(state).data?.[USER_AVATAR_SIZE_RANGE];
export const publicationInterestMaxCountSelector = state => settingsSelector(state).data?.[PUBLICATION_INTEREST_MAX_COUNT];
export const giftSizeRangeSelector = state => settingsSelector(state).data?.[GIFT_PHOTO_SIZE_RANGE];
export const chatMessageMaxLengthSelector = state => settingsSelector(state).data?.[CHAT_MESSAGE_MAX_LENGTH];
export const chatPhotoMaxSizeSelector = state => settingsSelector(state).data?.[CHAT_PHOTO_MAX_SIZE];
export const chatVideoMaxSizeSelector = state => settingsSelector(state).data?.[CHAT_VIDEO_MAX_SIZE];
